import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Bell, Award, Users, Cog, CheckCheck } from "lucide-react";

const CATS = [
  { k: "hepsi", l: "Tümü", icon: Bell },
  { k: "rozet", l: "Rozet", icon: Award },
  { k: "sosyal", l: "Sosyal", icon: Users },
  { k: "sistem", l: "Sistem", icon: Cog },
];
const catRenk = { rozet: "text-gold", sosyal: "text-terra", sistem: "text-sage" };

export default function Notifications() {
  const [cat, setCat] = useState("hepsi");
  const [items, setItems] = useState([]);

  const load = useCallback(() => {
    api.get("/notifications", { params: cat === "hepsi" ? {} : { kategori: cat } }).then((r) => setItems(r.data.items));
  }, [cat]);
  useEffect(() => { load(); }, [load]);

  const markAll = async () => { await api.post("/notifications/read-all"); load(); };
  const open = async (n) => { if (!n.read) await api.post(`/notifications/${n.id}/read`); load(); };

  return (
    <div className="max-w-2xl mx-auto" data-testid="notifications-page">
      <div className="flex items-center justify-between">
        <h1 className="font-serif text-4xl text-ink flex items-center gap-2"><Bell className="text-terra" size={26} /> Bildirimler</h1>
        <button onClick={markAll} data-testid="mark-all-read" className="text-sm text-terra hover:underline flex items-center gap-1"><CheckCheck size={15} /> Tümünü okundu işaretle</button>
      </div>
      <div className="flex gap-2 mt-5">
        {CATS.map((c) => (
          <button key={c.k} onClick={() => setCat(c.k)} data-testid={`notif-cat-${c.k}`}
            className={`text-sm px-4 py-1.5 rounded-full border flex items-center gap-1.5 ${cat === c.k ? "bg-terra text-white border-terra" : "border-line text-ink-2 hover:border-terra/40"}`}>
            <c.icon size={14} /> {c.l}
          </button>
        ))}
      </div>
      <div className="mt-5 space-y-2" data-testid="notif-list">
        {items.length === 0 && <p className="text-sm text-muted-foreground py-8 text-center">Bu kategoride bildirim yok.</p>}
        {items.map((n) => {
          const Inner = (
            <div className={`flex items-start gap-3 p-4 rounded-xl border ${n.read ? "border-line bg-surface" : "border-terra/30 bg-terra/5"}`}>
              <span className={`mt-0.5 ${catRenk[n.kategori]}`}>
                {n.kategori === "rozet" ? <Award size={18} /> : n.kategori === "sosyal" ? <Users size={18} /> : <Cog size={18} />}
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-ink">{n.message}</p>
                <p className="text-xs text-muted-foreground mt-0.5">{(n.created_at || "").slice(0, 10)}</p>
              </div>
              {!n.read && <span className="w-2 h-2 rounded-full bg-terra mt-2 shrink-0" />}
            </div>
          );
          return n.link ? (
            <Link key={n.id} to={n.link} onClick={() => open(n)} data-testid={`notif-${n.id}`} className="block">{Inner}</Link>
          ) : <div key={n.id} onClick={() => open(n)} data-testid={`notif-${n.id}`} className="cursor-pointer">{Inner}</div>;
        })}
      </div>
    </div>
  );
}
